import request from "./request";
import apis from "./apis";

const {
  allPeriodInfo,
  periodInfoById,
  updateStudyPeriodInfo,
} = apis.selfStudy;

const selfStudy = {
  getAllPeriodInfo: () => {
    return request.get(allPeriodInfo);
  },
  getPeriodInfoById: (data: Object) => {
    return request.get(periodInfoById, data);
  },
  updateStudyPeriodInfo: (data: Object) => {
    return request.put(updateStudyPeriodInfo, data);
  },
};

export default selfStudy;